module.exports = __webpack_public_path__ + "img/ape-marketing.7c201974.webp";